import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions, accountActions, spouseActions, chartsActions } from '../../../redux/root-action';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { isInternal } from '../../../utils/api';
import { analyticsTracking, responseStatus } from '../../../utils/constants';

const DeleteSpouseTextContainer = styled.div`
  margin: 32px 0 56px;
`;

const DeleteSpouseText = styled.span`
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};

  @media (max-width: 768px) {
    font-family: Nimbus Sans Regular;
    font-size: 16px;
    line-height: 1.38;
    letter-spacing: normal;
    font-weight: normal;
  }
`;

class DeleteSpouseModal extends Component<any> {
  props: any;
  state: any;

  componentDidUpdate(prevProps: any) {
    const { postSimulation, spouse, hideModal } = this.props;
    if (prevProps.spouse.deleteSpouse !== spouse.deleteSpouse && spouse.deleteSpouse === responseStatus.SUCCESS) {
      hideModal();
      postSimulation({});
    } else if (prevProps.spouse.deleteSpouse !== spouse.deleteSpouse && spouse.deleteSpouse === responseStatus.ERROR) {
      hideModal();
    }
  }

  handleDeleteSpouseAndAccounts = () => {
    const { deleteSpouse } = this.props;
    deleteSpouse();
  };

  render(): JSX.Element {
    const { spouse } = this.props;
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle="Delete Spouse" showCloseInMobile={true} />
        <ReactModalContent>
          <DeleteSpouseTextContainer>
            <DeleteSpouseText>
              If you choose to delete your spouse’s information, their accounts and Income / Expense event(s) will 
              also be permanently removed from your retirement savings balances and projections throughout the site.
            </DeleteSpouseText>
          </DeleteSpouseTextContainer>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Delete Spouse"
          buttonType="alert"
          handleCTAClick={this.handleDeleteSpouseAndAccounts}
          disabled={isInternal() || spouse.deleteSpouse === 'inProgress'}
          CTAButtonId={analyticsTracking.RIXDeleteSpouseandAccounts}
        />
      </React.Fragment>
    );
  }
}

export default connect(({ spouse }: any) => ({ spouse }), {
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  setCurrentView: accountActions.setCurrentView,
  deleteSpouse: spouseActions.deleteSpouse,
  postSimulation: chartsActions.postSimulation,
})(DeleteSpouseModal);
